import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n';
import { withRouterV6 as withRouter } from '../../../helpers/withRouterV6.jsx';

import get from 'lodash.get';

import * as donationActions from '../../donation/store/donationActions';
import clear from '../../../components/clear';
import { withPageTitle } from '../../../hocs';

import BasePageView from '../../../components/common/basePageView';
import DonationHeader from './donationHeader.jsx';
import { DonationDetails } from './donationDetails.jsx';
import RefundWindowContainer from '../refund-window';
import ReceiptWindowContainer from '../receipt-window';
import { DonationShortDescription } from './donationShortDescription.jsx';
import { DonationPaymentDetails } from './donationPaymentDetails.jsx';
import { DonationAdditionalInformation } from './donationAdditionalInformation.jsx';
import { DonationGiftMatchingInformation } from './donationGiftMatchingInformation.jsx';
import { DonationPageInformation } from './donationPageInformation.jsx';
import { DonationGiftAid } from './giftAid/donationGiftAid';

import { Record } from '../../../modules/bin/utility';

import config from '../../../constants';

class DonationViewPageContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isShowEmptyFields: false,
      displayOrgCurrency: false,
    };
  }

  componentDidMount() {
    const donationId = this.props.match.params.id;
    this.props.donationActions.getRecord(donationId);
    this.props.donationActions.getRelatedRecord(donationId);
  }

  onRefundClick = (item) => {
    this.props.donationActions.showRefundConfirmation(item);
  };

  changeVisibilityEmptyFields = () => {
    this.setState(prevState => ({
      isShowEmptyFields: !prevState.isShowEmptyFields,
    }));
  };

  onReissueClick = (item) => {
    if (item.email) {
      this.props.donationActions.showReceiptConfirmation(item);
    } else {
      this.props.donationActions.getReceiptMessageError('saveRecord');
    }
  };

  toggleCurrencyDisplay = () => {
    this.setState(prevState => ({
      displayOrgCurrency: !prevState.displayOrgCurrency,
    }));
  }

  render() {
    const donation = Record.isRecordReady(this.props.record)
      ? this.props.record.data.data
      : {};

    const customPaymentPlatform = Record.isRecordReady(this.props.relatedRecord)
      ? get(this.props.relatedRecord, 'data.data.paymentPlatform')
      : null;

    const donorCommunication = Record.isRecordReady(this.props.relatedRecord)
      ? get(this.props.relatedRecord, 'data.data.donorCommunication')
      : null;

    const flags = Record.isRecordReady(this.props.relatedRecord)
      ? get(this.props.relatedRecord, 'data.data.flags', [])
      : [];

    return (
      <BasePageView
        isLoading={this.props.isLoading}
        isLoadingError={this.props.isLoadingError}
        backLink={config.DEFAULT_DONATIONS_URL}
        backLinkTitle="Back to donations"
      >
        <RefundWindowContainer />
        <ReceiptWindowContainer />

        <div className="view-detail">
          <DonationHeader
            donation={donation}
            relatedRecord={this.props.relatedRecord}
            isShowEmptyFields={this.state.isShowEmptyFields}
            changeVisibilityEmptyFields={this.changeVisibilityEmptyFields}
            displayOrgCurrency={this.state.displayOrgCurrency}
            onToggleCurrencyDisplay={this.toggleCurrencyDisplay}
            isSystemAdmin={this.props.isSystemAdmin}
            openModalOnReissueClick={this.onReissueClick}
            openModalOnRefundClick={this.onRefundClick}
            customPaymentPlatform={customPaymentPlatform}
            isPaymentPlatformsLoaded={Record.isRecordReady(this.props.relatedRecord)}
          />
          <div className="view-detail-wrapper">
            <div className="view-detail-main-section">
              <DonationShortDescription
                donation={donation}
                isShowEmptyFields={this.state.isShowEmptyFields}
              />
              <DonationDetails
                donation={donation}
                isShowEmptyFields={this.state.isShowEmptyFields}
                displayOrgCurrency={this.state.displayOrgCurrency}
              />
              <DonationAdditionalInformation
                donation={donation}
                isShowEmptyFields={this.state.isShowEmptyFields}
                donorCommunication={donorCommunication}
                flags={flags}
              />
              <DonationGiftAid
                donation={donation}
                isShowEmptyFields={this.state.isShowEmptyFields}
              />
              <DonationGiftMatchingInformation
                donation={donation}
                isShowEmptyFields={this.state.isShowEmptyFields}
              />
              <DonationPageInformation donation={donation} />
            </div>
            <div className="view-detail-side-section">
              <DonationPaymentDetails
                donation={donation}
                customPaymentPlatform={customPaymentPlatform}
                isSystemAdmin={this.props.isSystemAdmin}
                isRelatedLoaded={Record.isRecordReady(this.props.relatedRecord)}
                displayOrgCurrency={this.state.displayOrgCurrency}
              />
            </div>
          </div>
        </div>
      </BasePageView>
    );
  }
}

const mapState = ({ donation, session }) => {
  return {
    isLoading: Record.isRecordLoading(donation.record),
    isSystemAdmin: session.isSystemAdmin,
    record: donation.record,
    saveRecord: donation.saveRecord,
    relatedRecord: donation.relatedRecord
  };
};

const mapDispatch = (dispatch) => {
  return {
    donationActions: bindActionCreators(donationActions, dispatch)
  };
};

const titleResolver = (props) => {
  const donationId = get(props, 'match.params.id') || '';
  if (!donationId) return I18n.t('page-titles.donations.view-default');
  return I18n.t('page-titles.donations.view', { id: donationId });
};

const DonationViewPage = withRouter(
  clear(connect(mapState, mapDispatch)(withPageTitle(titleResolver)(DonationViewPageContainer)))
);
export default DonationViewPage;
